import { connect } from "react-redux";
import NetworksList from "./NetworksList";

import { init, getReferentielsList } from 'redux/actions/referentielsActions';

const mapStateToProps = (state, ownProps) => {
	return {
		networksList: state.networks.networksList,
		page: state.networks.page,
		pages: state.networks.pages,
		pageSize: state.networks.pageSize,
		nbItems: state.networks.networksList.length,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		init: sectionName => dispatch(init(sectionName)),
		getNext: page => {
			const nextPage = page;
			
			dispatch(getReferentielsList({ page: nextPage }, "networks"));
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(NetworksList);


// WEBPACK FOOTER //
// src/containers/admin/network/NetworksContainer.js